import AuthLayout from "layouts/authLayout/AuthLayout";
import { useEffect, useState } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link, useSearchParams } from "react-router-dom";
import { UserController } from "services/user/UserController";
import { Card, Footer, Header } from "stories";
import { FooterChildren, HeaderChildren } from "../auth_views";
import classes from "./index.module.scss";

export const EmailVerification = () => {
	const user = UserController();
	const [query] = useSearchParams();
	const token = query.get("token");
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState({
		visible: false,
		text: "",
		type: "success",
	});
	useEffect(() => {
		setLoading(true);
		user
			.verifyEmail(token)
			.then(() => {
				setMessage({
					visible: true,
					text: "Email verified successfully",
					type: "success",
				});
			})
			.catch((err) => {
				setMessage({
					visible: true,
					text: err.data,
					type: "danger",
				});
			})
			.finally(() => {
				setLoading(false);
			});
	}, []); //eslint-disable-line

	return (
		<AuthLayout headerSpacing>
			<Helmet>
				<title>Email Verification | Fundever</title>
			</Helmet>
			<Header>
				<HeaderChildren linkedTo={"/sign-in"} />
			</Header>
			<Container fluid>
				<Row>
					<Col md={{ span: 6, offset: 3 }}>
						<div className={classes["wrapper"]}>
							<Card>
								<div className={classes["content-wrapper"]}>
									<div className={classes["title"]}>Email Verification</div>
									{loading && (
										<>
											<div
												data-testid={"loading"}
												className={classes["loading"]}
											/>
											<div>Verifying your email address...</div>
										</>
									)}
									{!loading && message.visible && (
										<Alert className="w-100" variant={message.type}>
											<p className="mb-0 capitalize">{message.text}</p>
											{message.type === "success" && (
												<p className="mb-0 mt-2">
													Back to{" "}
													<Link className="hyper" to="sign-in">
														Sign in
													</Link>{" "}
													page
												</p>
											)}
										</Alert>
									)}
								</div>
							</Card>
						</div>
					</Col>
				</Row>
			</Container>
			<Footer>
				<FooterChildren />
			</Footer>
		</AuthLayout>
	);
};
